const factory = [
  {
    path: "/factory/manage",
    name: "factoryManage",
    component: () => import("@/view/factory/manage"),
  },
  {
    path: "/factory/project",
    name: "factoryProject",
    component: () => import("@/view/factory/projectInfo"),
  },
];
export default factory;
